import React, { Component } from 'react';
import { AccentColor } from 'helpers/AccentColorHelper';

class SubheaderText extends Component {
  render() {
    return (
      <div className={this.props.columnWidth || 'col-xs-4'}>
        <div style={{ textAlign: 'center' }}>
          <button
            type="button"
            className="link-button"
            onClick={this.props.onClickAction}
            style={{
              color: AccentColor(),
              fontFamily: 'Circular-Bold',
              borderBottom: this.props.openView === this.props.actionView ? '2px solid' : 'none',
            }}
          >
            {this.props.subheaderText}
          </button>
        </div>
      </div>
    );
  }
}

export default SubheaderText;
